<template>
  <v-dialog  width="750px" :value="show" @input="$emit('change-value', $event)">
    <v-card height="550px">
      <v-card-text class="h-100">
        <v-layout class="h-100">
          <v-flex md4>
            <v-layout class="h-100" column>
              <v-flex md1 class="text-xs-center">
                <span class="title pa-0">
                  Pagos
                </span>
              </v-flex>
              <v-flex>
                <v-layout v-for="(bar,i) in data" :key="`bar${i}`" row wrap>
                  <v-flex xs12>
                    {{ bar.title }}: {{new Intl.NumberFormat('es-VE').format(bar.total)}}
                    <!-- / 
                    {{ new Intl.NumberFormat('es-VE').format(bar.amount)}} $ -->
                  </v-flex>
                  <v-flex xs12 style="position:relative;">
                    <v-progress-linear
                      height="15"
                      background-color="bar-background"
                      :value="bar.value" />
                    <span class="bar-text">{{new Intl.NumberFormat('es-VE', {maximumFractionDigits: 2}).format(bar.value)}}%</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-divider
            class="vertical mx-3"
            inset
            ></v-divider>
          </v-flex>
          <v-flex md8>
            <v-layout class="h-100" column>
              <v-flex md1 class="text-xs-center">
                <span class="title pa-0">
                  Estados de clientes {{titleStatusT}}
                </span>
              </v-flex>
              <v-flex>
                <vue-perfect-scrollbar style="height: 450px;">
                  <v-layout class="h-100" justify-center>
                    <v-flex xs12 >
                      <template v-if="contactedStatuses.length > 0 || (uncontactedStatuses.length > 0 && titleStatus === 'Gestionados')">
                        <v-layout row wrap>
                          <v-flex
                          md12
                          mt-2
                          class="text-xs-center beautiful-list"                  
                          >
                            <span v-if="titleStatus === 'Gestionados'">
                              Contactados
                            </span>
                            <div>
                              <v-list-tile class="b-borders" v-for="(status, i) in contactedStatuses" :key="i">
                                <v-layout row wrap class="f0-9em">
                                  <v-flex class="text-xs-left" md1>
                                    <v-icon small class="pr-3">fas fa-{{ showStatusIcon(status.id) }}</v-icon>
                                  </v-flex>
                                  <v-flex class="text-xs-left" md3>
                                    {{ showStatusName(status.id) }}
                                  </v-flex>
                                  <v-flex class="text-xs-center " md4>
                                    {{new Intl.NumberFormat('es-VE').format(status.quantity)}}
                                  </v-flex>
                                  <v-flex class="text-xs-right " md4>
                                    <span class="text-medium-light green--text">
                                      {{percent(status.quantity)}}%
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>
                              <v-list-tile>
                                <v-layout row wrap class="f0-9em">
                                  <v-flex class="text-xs-left" md4>
                                    <strong>Total</strong>
                                  </v-flex>
                                  <v-flex md4 class="text-xs-center">
                                    {{new Intl.NumberFormat('es-VE').format(statusTotal)}}
                                  </v-flex>
                                  <v-flex md4 class="text-xs-right">
                                    <span class="text-medium-light green--text">
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>
                            </div>
                          </v-flex>
                          <v-flex class="text-xs-center beautiful-list" mt-2 v-if="titleStatus === 'Gestionados'" md12>
                            <span>
                              No contactados
                            </span>
                            <div>
                              <v-list-tile class="b-borders" v-for="(status, i) in uncontactedStatuses" :key="i">
                                <v-layout row wrap class="f0-9em">
                                  <v-flex class="text-xs-left" md1>
                                    <v-icon small class="pr-3">fas fa-{{ showStatusIcon(status.id) }}</v-icon>
                                  </v-flex>
                                  <v-flex class="text-xs-left" md3>
                                    {{ showStatusName(status.id) }}
                                  </v-flex>
                                  <v-flex class="text-xs-center " md4>
                                    {{new Intl.NumberFormat('es-VE').format(status.quantity)}}
                                  </v-flex>
                                  <v-flex class="text-xs-right " md4>
                                    <span class="text-medium-light red--text">
                                      {{percentUn(status.quantity)}}%
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>
                              <v-list-tile @click="openStatusReport(5, 'all')">
                                <v-layout row wrap class="f0-9em">
                                  <v-flex class="text-xs-left" md4>
                                    <strong>Total</strong>
                                  </v-flex>
                                  <v-flex md4 class="text-xs-center">
                                    {{new Intl.NumberFormat('es-VE').format(unstatusTotal)}}
                                  </v-flex>
                                  <v-flex md4 class="text-xs-right">
                                    <span class="text-medium-light red--text">
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>
                            </div>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else>
                        <v-list-tile>
                          <v-layout row wrap>
                            <v-flex md12 class="text-xs-center">
                              No se encontraron resultados
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                      </template>
                    </v-flex>
                  </v-layout>
                </vue-perfect-scrollbar>
              </v-flex>
              <v-flex>
                <v-layout class="h-100" justify-end align-end>
                  <v-btn flat  @click="$emit('change-value', false)">Cerrar</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import statusMixins from '@/mixins/status';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import _ from 'lodash';

export default {
  mixins: [
    statusMixins,
  ],
  components: {
    VuePerfectScrollbar,
  },
  props: {
    identifier: {
      required: true,
      type: Number,
    },
    show: {
      required: true,
      type: Boolean,
    },
    filters: {
      required: true,
      type: Object,
    },
    titleStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [
        {
          title: 'Mismo día',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: 'Siguiente día',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: '2 días',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: '3 días',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: '7 días',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: '15 días',
          value: 0,
          total: 0,
          amount: 0,
        },
        {
          title: '30 días',
          value: 0,
          total: 0,
          amount: 0,
        },
      ],
      contactedStatuses: [],
      uncontactedStatuses: [],
    };
  },
  computed: {
    statusTotal() {
      let total = 0;
      for (let i = 0; i < this.contactedStatuses.length; i += 1) {
        total += Number(this.contactedStatuses[i].quantity);
      }
      return total;
    },
    unstatusTotal() {
      let total = 0;
      for (let i = 0; i < this.uncontactedStatuses.length; i += 1) {
        total += Number(this.uncontactedStatuses[i].quantity);
      }
      return total;
    },
    titleStatusT() {
      let title = this.titleStatus.toLowerCase();
      if (['contacto útil', 'compromiso'].includes(title)) {
        title = 'contactados';
      }
      return title;
    },
  },
  methods: {
    percent(count) {
      return new Intl.NumberFormat('es-VE', { maximumFractionDigits: 2 }).format((count * 100) / this.statusTotal);
    },
    percentUn(count) {
      return new Intl.NumberFormat('es-VE', { maximumFractionDigits: 2 }).format((count * 100) / this.unstatusTotal);
    },
    getInfo() {
      this.axios.get('efectivity/detail', {
        params: {
          ...this.filters,
          identifier: this.identifier,
        },
      }).then((res) => {
        if (res.data.status.length > 0) {
          this.contactedStatuses = _.remove(res.data.status, x => x.contacted === 'reached');
          this.uncontactedStatuses = res.data.status;
        } else {
          this.contactedStatuses = [];
          this.uncontactedStatuses = [];
        }
        if (res.data.payments) {
          this.data[0].total = res.data.payments.sameDay;
          this.data[1].total = res.data.payments.nextDay;
          this.data[2].total = res.data.payments.twoDays;
          this.data[3].total = res.data.payments.threeDays;
          this.data[4].total = res.data.payments.nextWeek;
          this.data[5].total = res.data.payments.twoWeeks;
          this.data[6].total = res.data.payments.nextMonth;
          this.data[0].value = (this.data[0].total * 100) / res.data.payments.quantity;
          this.data[1].value = (this.data[1].total * 100) / res.data.payments.quantity;
          this.data[2].value = (this.data[2].total * 100) / res.data.payments.quantity;
          this.data[3].value = (this.data[3].total * 100) / res.data.payments.quantity;
          this.data[4].value = (this.data[4].total * 100) / res.data.payments.quantity;
          this.data[5].value = (this.data[5].total * 100) / res.data.payments.quantity;
          this.data[6].value = (this.data[6].total * 100) / res.data.payments.quantity;
        } else {
          for (let i = 0; i < this.data.length; i += 1) {
            this.data[i].value = 0;
            this.data[i].total = 0;
          }
        }
      });
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.getInfo();
        }
      },
    },
  },
};
</script>
<style scoped>
.vertical {
  border: none;
  border-left: 1px solid hsl(200, 2%, 79%);
  height: 100%;
  border-radius: 20%;
  width: 1px;
}
.progress-linear__bar, 
.progress-linear__bar__determinate,
.bar-background {
  border-radius: 300px;
}
.bar-background {
  background: #ccc2c2;
}
.beautiful-list {
    border: 1px solid #d6d3d3;
    border-width: 2px;
}
.bar-text {
  position: absolute;
  bottom: 12px;
  left: 7px;
  color: #fff;
  z-index: 12;
  font-size: 13px;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/InfoModal.vue